import moment from "moment";
import { message } from "antd";

// formata as datas para o padrão que o backend espera (YYYY-MM-DD)
export const formatDate = (values) => ({
  ...values,
  start_date: values.start_date?.format("YYYY-MM-DD"),
  end_date: values.end_date?.format("YYYY-MM-DD"),
});

// normaliza campos que podem vir como string ou array
export const normalizeToArray = (value) => {
  if (!value) return [];

  // se já for array, retorna ele mesmo
  if (Array.isArray(value)) return value;

  // se for string, separa pela vírgula
  if (typeof value === "string") {
    return JSON.parse(value);
  }

  // qualquer outro caso
  return [];
};

// normaliza banner vindo da API
export const normalizeBanner = (bannerData) => {
  if (!bannerData) return;

  return {
    ...bannerData,

    // converte string de data para objeto Moment
    start_date: bannerData?.start_date ? moment(bannerData.start_date) : null,
    end_date: bannerData?.end_date ? moment(bannerData.end_date) : null,

    // garante que esses campos sempre sejam arrays
    profile_can_view: normalizeToArray(bannerData?.profile_can_view),
    plan_name_can_view: normalizeToArray(bannerData?.plan_name_can_view),

    priority:
      bannerData?.priority !== undefined && bannerData?.priority !== null
        ? Number(bannerData.priority)
        : bannerData?.priority,
  };
};

export const exportBannerJson = (form, bannerData) => {
  try {
    // pega os valores atuais do formulário
    const value = form.getFieldsValue();

    // junta os dados do banner com os valores atualizados do form
    const normalized = { ...bannerData, ...value };

    // transforma os dados em arquivo JSON
    const blob = new Blob([JSON.stringify(normalized, null, 2)], {
      type: "application/json",
    });
    //cria URL temporária para download
    const url = URL.createObjectURL(blob);

    //Cria o link
    const a = document.createElement("a");
    a.href = url;

    //define nome do arquvi baixado
    a.download = `banner_${normalized.banner_id || "data"}.json`;
    a.click();

    // remove a URL temporária da memória
    URL.revokeObjectURL(url);
  } catch (error) {
    console.log(error);
    message.error("Erro ao exportar");
  }
};

export const importBannerJson = (file, form) => {
  // cria leitor de arquivo
  const reader = new FileReader();

  reader.onload = (e) => {
    try {
      // converte o conteúdo do JSON em objeto JavaScript
      const jsonData = JSON.parse(e.target.result);

      // normaliza os dados para o formato do formulário
      const normalizedData = normalizeBanner(jsonData);

      // preenche o formulário com os dados importados
      form.setFieldsValue(normalizedData);
    } catch (error) {
      console.log(error);
      message.error("Erro ao importar");
    }
  };
  // lê o arquivo como texto
  reader.readAsText(file);
};
